import { makeApiCall, ApiResponse, ApiError } from "./index";

const BASE_URL = process.env.REACT_APP_API_AUTHENTICATION_URL;
const TRAIL_URL = process.env.REACT_APP_API_AUTHENTICATION_URL_FREE_TRIAL;

// POST request
export function Login(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users/login`, "POST", body, {
    isPublicRoute: true,
  });
}

export function addTrailUsers(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${TRAIL_URL}trailUsers`, "POST", body);
}
